/**
 * Import Dependency
 */
import { createAction } from 'redux-actions'
import * as _ from 'lodash'
import collection from 'lodash/collection'
import orderApi from 'services/api/order'
import promoCode from 'services/api/promo_code'
import * as ActionTypes from 'constants/actionType'
import * as soldOutActions from 'actions/components/soldOut'
import * as waiterActions from 'actions/components/waiter'
import helpers from 'helpers'

/**
 * Declare Variable
 */
const addStashAction = createAction(ActionTypes.ADD_STASH)
const resetStashAction = createAction(ActionTypes.RESET_STASH)
const addOrderAction = createAction(
  ActionTypes.ADD_ORDER,
  (params) => params,
  (params, selectOptionIndex) => ({ selectOptionIndex }),
)
const updateCanPayAction = createAction(ActionTypes.UPDATE_CAN_PAY)
const cancelOrderAction = createAction(ActionTypes.CANCEL_ORDER)
const deleteOrderByDishIdAction = createAction(ActionTypes.DELETE_ORDER_BY_DISH_ID)
const updateSetOrderConfirmedStatusAction = createAction(ActionTypes.UPDATE_SET_ORDER_CONFIRMED_STATUS)
const updateOrderRemarkAction = createAction(ActionTypes.UPDATE_ORDER_REMARK)
const resetOrderAction = createAction(ActionTypes.RESET_ORDER)
const requestCreateBasketAction = createAction(ActionTypes.REQUEST_CREATE_BASKET)
const createBasketAction = createAction(ActionTypes.CREATE_BASKET)
const addBasketAction = createAction(ActionTypes.ADD_BASKET)
const resetBasketAction = createAction(ActionTypes.RESET_BASKET)
const clearBasketAction = createAction(ActionTypes.CLEAR_BASKET)
const payBasketAction = createAction(ActionTypes.PAY_ORDER)
const requestServiceAction = createAction(ActionTypes.REQUEST_SERVICE)
const setFilteredByMeAction = createAction(ActionTypes.SET_FILTERED_BY_ME)
const setIsTakeawayAction = createAction(ActionTypes.SET_IS_TAKE_AWAY)
const setIsDeliveryAction = createAction(ActionTypes.SET_IS_DELIVERY)
const setIsShopAction = createAction(ActionTypes.SET_IS_SHOP)
const setIsStoreDeliveryAction = createAction(ActionTypes.SET_IS_STORE_DELIVERY)
const setShippingAction = createAction(ActionTypes.SET_SHIPPING)
const setCardOnlyAction = createAction(ActionTypes.SET_CARD_ONLY)
const setTakeawayOrdersAction = createAction(ActionTypes.SET_TAKEAWAY_ORDERS)
const setTakeawayStatusAction = createAction(ActionTypes.SET_TAKEAWAY_STATUS)
const setTakeawayAvailableAction = createAction(ActionTypes.SET_TAKEAWAY_AVAILABLE)
const setOutTradeNoAction = createAction(ActionTypes.SET_OUT_TRADE_NO)
const setDeliveryAvailableAction = createAction(ActionTypes.SET_DELIVERY_AVAILABLE)
// const completeTakeawayOrderAction = createAction(ActionTypes.COMPLETE_TAKEAWAY_ORDER)
const updatePromoCodeAction = createAction(ActionTypes.UPDATE_PROMO_CODE)
const setTakeawayDiscountAction = createAction(ActionTypes.SET_TAKEAWAY_DISCOUNT)
const redeemPromoCodeAction = createAction(ActionTypes.REDEEM_PROMO_CODE)
const removePromoCodeAction = createAction(ActionTypes.REMOVE_PROMO_CODE)
const updatePerItemRemarkAction = createAction(ActionTypes.UPDATE_PER_ITEM_REMARK)
const removePerItemRemarkAction = createAction(ActionTypes.REMOVE_PER_ITEM_REMARK)

function getLocalState () {
  try {
    return JSON.parse(window.localStorage.getItem('state'))
  } catch (error) {
    return {}
  }
}

export const addToOrder = (params, selectOptionIndex) => async (dispatch) => {
  // inject stepNo into item
  if (params.setStep) {
    params = {
      ...params,
      stepNo: params.category.steps.findIndex((ele) => {
        return ele.key === params.setStep.key
      }),
    }
  }

  try {
    dispatch(addOrderAction(params, selectOptionIndex))
    // Reset waiter number pad value after add order.
    dispatch(waiterActions.resetWaiterNumberPadValue())
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const cancelOrder = (params) => async (dispatch) => {
  try {
    dispatch(cancelOrderAction(params))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

// not called in checkout page
export const deleteOrderByDishId = (params) => async (dispatch) => {
  try {
    dispatch(deleteOrderByDishIdAction(params))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const setStash = (params) => async (dispatch) => {
  try {
    dispatch(addStashAction(params))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const updateSetOrderConfirmedStatus = (params) => async (dispatch) => {
  try {
    dispatch(updateSetOrderConfirmedStatusAction(params))
  } catch (error) {
    return Promise.reject(error)
  }
}

export const resetStash = () => async (dispatch) => {
  try {
    dispatch(resetStashAction())
    return Promise.resolve('stash')
  } catch (error) {
    return Promise.reject(error)
  }
}

export const addToBasket = (params) => async (dispatch) => {
  try {
    dispatch(addBasketAction(params))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const resetOrder = () => async (dispatch) => {
  try {
    dispatch(resetOrderAction())
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getBasket = (params) => async (dispatch) => {
  try {
    const res = await orderApi.getOrder(params.id)
    return Promise.resolve(res)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const setTakeawayAvailable = (params) => async (dispatch) => {
  try {
    dispatch(setTakeawayAvailableAction(params))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const setOutTradeNo = (params) => async (dispatch) => {
  try {
    dispatch(setOutTradeNoAction(params))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const setDeliveryAvailable = (params) => async (dispatch, getState) => {
  try {
    const merchant = getState().merchant
    if (merchant) {
      dispatch(setDeliveryAvailableAction(_.get(merchant, 'setting.enableDelivery') && params))
    } else {
      dispatch(setDeliveryAvailableAction(params))
    }
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const requestCreateBasket = (params) => async (dispatch) => {
  try {
    dispatch(requestCreateBasketAction(params))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const createBasket = (params) => async (dispatch, getState) => {
  try {
    const state = getState()
    let basket
    if (!params.id) {
      const isDelivery = 'isDelivery' in params ? params.isDelivery : state.basket.isDelivery
      const isStoreDelivery = state.basket.isStoreDelivery
      basket = await orderApi.createOrder({
        merchantID: params.merchantId,
        table: params.table,
        isDelivery,
        isStoreDelivery,
        memberID: _.get(getLocalState(), 'query.params.u'),
      })
    } else {
      basket = params
    }
    if (_.get(state, 'basket.promoCode')) {
      basket = {
        ...basket,
        promoCode: _.get(state, 'basket.promoCode'),
        discount: _.get(state, 'basket.discount'),
      }
    }
    dispatch(createBasketAction(basket))
    return Promise.resolve(basket)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const joinBasket = (params) => async (dispatch) => {
  try {
    const res = await orderApi.joinOrder(params.id)
    dispatch(createBasketAction(res))
    return Promise.resolve(res)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const setBasketRemark = (remark) => async (dispatch) => {
  try {
    dispatch(
      updateOrderRemarkAction({
        remark: remark,
      }),
    )
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const resetBasket = () => async (dispatch) => {
  try {
    dispatch(resetBasketAction())
    return Promise.resolve('basket')
  } catch (error) {
    return Promise.reject(error)
  }
}
export const clearBasket = () => async (dispatch) => {
  try {
    dispatch(clearBasketAction())
    return Promise.resolve('basket')
  } catch (error) {
    return Promise.reject(error)
  }
}
export const submitDineinPayment = (id, params) => async (dispatch) => {
  try {
    const res = await orderApi.submitDineinPayment(id, params)
    return Promise.resolve(res)
  } catch (error) {
    return Promise.reject(error)
  }
}
export const submitBasket = (params) => async (dispatch) => {
  params.items.forEach((ele) => {
    if (ele.items) {
      ele.items.sort((a, b) => {
        return a.stepNo - b.stepNo
      })
    }
  })

  try {
    const items = extractOrderItems(params)
    await orderApi.submitOrder({
      id: params.id,
      uuid: params.uuid,
      items: items,
      remark: params.remark,
      promoCode: params.promoCode,
      isTakeout: params.isTakeout,
      merchant: params.merchant,
      ignoreUnavailable: params.ignoreUnavailable,
    })
    dispatch(resetBasketAction(params))
    dispatch(updateCanPayAction(true))
    return Promise.resolve()
  } catch (err) {
    if (
      _.get(err, ['response', 'status']) === 400 &&
			!['invalid timeslot', 'submit too fast', 'cutoff order'].includes(
			  _.get(err, ['response', 'data', 'error']),
			)
    ) {
      dispatch(requestCreateBasketAction())
    }

    if (
    // > 部分商品售完，跳 soldOutDialog。(Footer)
      _.get(err, ['response', 'status']) === 500 &&
			_.get(err, ['response', 'data', 'error']) === 'some items are not available'
    ) {
      dispatch(soldOutActions.updateSoldOutItems(_.get(err, ['response', 'data', 'items'])))
      dispatch(soldOutActions.updateSoldOutCanContinue(_.get(err, ['response', 'data', 'canContinue'])))
      dispatch(soldOutActions.updateSoldOutInventory(_.get(err, ['response', 'data', 'inventory'])))
      dispatch(soldOutActions.updateDisplaySoldOutDialogFooter(true))
    }

    if (
      _.get(err, ['response', 'status']) === 500 &&
			_.get(err, ['response', 'data', 'error']) === 'amount_too_small' &&
			_.get(err, ['response', 'data', 'minAmount'])
    ) {
      return Promise.reject({
        error: 'invalid.amount_too_small',
        values: { minAmount: err.response.data.minAmount },
      })
    }

    if (
      _.get(err, ['response', 'status']) === 400 &&
			_.get(err, ['response', 'data', 'error']) === 'submit too fast'
    ) {
      let errorText = ''
      if (params.merchant.setting.batchInterval < 60) {
        errorText = params.merchant.setting.batchInterval + ' second'
      } else {
        errorText = Math.round(params.merchant.setting.batchInterval / 60) + ' minutes'
      }

      console.log('test: ', errorText)
      return Promise.reject({
        error: 'submit too fast',
        values: { batchInterval: errorText },
      })
    }

    return Promise.reject(_.get(err, ['response', 'data']))
  }
}

export const submitTakeawayBasket = (params) => async (dispatch) => {
  try {
    const items = extractOrderItems(params)
    const res = await orderApi.submitTakeawayOrder({
      ..._.pick(params, [
        'id',
        'uuid',
        'remark',
        'takeawayInfo', // > address, name, tel, pickup...
        'promoCode',
        'merchant',
        'deliveryType',
        'ignoreUnavailable',
        'shipping',
        'needTableware',
        'card',
        'payment',
      ]),
      items,
    })
    // set takeawayorders since it's paid
    dispatch(setTakeawayStatus('pending'))
    dispatch(setTakeawayDiscount(res.discount))
    dispatch(setTakeawayOrders(res.items))
    dispatch(resetBasketAction(params))
    return Promise.resolve(res)
  } catch (err) {
    const res = err.response || {}
    if (_.get(err, ['response', 'status']) === 403 && _.get(err, ['response', 'data', 'error'])) {
      dispatch(requestCreateBasketAction())
    }

    if (
      _.get(err, ['response', 'status']) === 400 &&
			_.get(err, ['response', 'data', 'error']) === 'out of time range'
    ) {
      return Promise.reject({ error: 'invalid.timeslot' })
    }

    if (
      _.get(err, ['response', 'status']) === 500 &&
			_.get(err, ['response', 'data', 'error']) === 'amount_too_small' &&
			_.get(err, ['response', 'data', 'minAmount'])
    ) {
      return Promise.reject({
        error: 'invalid.amount_too_small',
        values: { minAmount: err.response.data.minAmount },
      })
    }

    if (
      _.get(err, ['response', 'status']) === 500 &&
			_.get(err, ['response', 'data', 'error']) === 'customer submit locked'
    ) {
      throw err
    }

    if (
    // > 部分商品售完，跳 soldOutDialog。(TakeawayPaymentSummary)
      _.get(err, ['response', 'status']) === 500 &&
			_.get(err, ['response', 'data', 'error']) === 'some items are not available'
    ) {
      dispatch(soldOutActions.updateSoldOutItems(_.get(err, ['response', 'data', 'items'])))
      dispatch(soldOutActions.updateSoldOutCanContinue(_.get(err, ['response', 'data', 'canContinue'])))
      dispatch(soldOutActions.updateSoldOutInventory(_.get(err, ['response', 'data', 'inventory'])))
      dispatch(soldOutActions.updateDisplaySoldOutDialogTakeawayPaymentSummary(true))
      return Promise.reject({ isRenderToast: false })
    }

    if (_.get(err, ['response', 'data']) && _.get(err, ['response', 'status'])) {
      return Promise.reject(err.response)
    }

    return Promise.reject(res.data ? res.data.error_code || '400' : res)
  }
}

const extractOrderItems = (params) => {
  params.items.forEach((ele) => {
    if (ele.items) {
      ele.items.sort((a, b) => {
        return a.stepNo - b.stepNo
      })
    }
  })

  let setMenuIndex = -1

  const items = collection.flatMap(params.items, (item) => {
    const items = item.items ? item.items.filter((menu) => !menu.dishId.startsWith('0-')) : [item]

    if (item.steps) {
      setMenuIndex = setMenuIndex + 1
    }

    return collection.flatMap(items, (item) => {
      const quantity = Array(item.quantity).fill('i')
      return quantity.map((i, index) => {
        return {
          menuID: item.menuId ? item.menuId : item.dishId,
          setMenuID: item.menuId ? item.dishId : null,
          name: item.dish,
          price: item.price,
          setMenuIndex: item.setStep ? setMenuIndex : null,
          discount: item.discount,
          stepNo: item.stepNo ? item.stepNo : null,
          // > 一次點 n 個 item 的時候 options 不會增加
          options: item.options[index]
            ? item.options[index].map((opt) => ({
              optionID: opt.id,
              name: opt.name,
              price: opt.price,
              quantity: opt.quantity ? opt.quantity : 1,
            }))
            : item.options[0].map((opt) => ({
              optionID: opt.id,
              name: opt.name,
              price: opt.price,
              quantity: opt.quantity ? opt.quantity : 1,
            })),
          remarks: item.remarks[index] ? item.remarks[index] : [],
        }
      })
    })
  })

  return items
}
window.extractOrderItems = extractOrderItems

export const payBasket = (params) => async (dispatch) => {
  try {
    await orderApi.payOrder(params.id, params.paymentMethod)
    dispatch(payBasketAction(params))
    return Promise.resolve()
  } catch (error) {
    const res = error.response
    return Promise.reject(res.data ? res.data.error_code : res)
  }
}

export const requestService = (params) => async (dispatch) => {
  try {
    await orderApi.requestService(params.id)
    dispatch(requestServiceAction(params))
    return Promise.resolve()
  } catch (error) {
    const res = error.response
    return Promise.reject(res.data ? res.data.error_code : res)
  }
}

export const setFilteredByMe = (params) => async (dispatch) => {
  try {
    dispatch(setFilteredByMeAction(params))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const setIsTakeaway = (params) => async (dispatch) => {
  try {
    dispatch(setIsTakeawayAction(params))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const setIsDelivery = (params) => async (dispatch) => {
  try {
    dispatch(setIsDeliveryAction(params))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}
export const setIsShop = (params) => async (dispatch) => {
  try {
    dispatch(setIsShopAction(params))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}
export const setIsStoreDelivery = (params) => async (dispatch) => {
  try {
    dispatch(setIsStoreDeliveryAction(params))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const setShipping = (params) => async (dispatch) => {
  try {
    dispatch(setShippingAction(params))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const setCardOnly = (params) => async (dispatch) => {
  try {
    const isCardOnly = params === true
    dispatch(setCardOnlyAction(isCardOnly))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const setTakeawayOrders = (params) => async (dispatch) => {
  try {
    dispatch(setTakeawayOrdersAction(params))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const setTakeawayStatus = (params) => async (dispatch) => {
  try {
    dispatch(setTakeawayStatusAction(params))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getRecentPaymentInfo = (params) => async (dispatch) => {
  try {
    const res = await orderApi.getRecentPaymentInfo()
    return Promise.resolve(res)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const updatePromoCode = (code) => async (dispatch) => {
  try {
    dispatch(updatePromoCodeAction(code))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const updatePerItemRemark = (params) => async (dispatch) => {
  try {
    dispatch(updatePerItemRemarkAction(params))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}
export const setTakeawayDiscount = (params) => async (dispatch) => {
  try {
    dispatch(setTakeawayDiscountAction(params))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const removePerItemRemark = (params) => async (dispatch) => {
  try {
    dispatch(removePerItemRemarkAction(params))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const redeemPromoCode = (params) => async (dispatch) => {
  try {
    const res = await promoCode.redeemPromoCode(params)
    if (_.get(res, 'success')) {
      dispatch(redeemPromoCodeAction(res))
      // return Promise.resolve(res)
    }
    return Promise.resolve(res)
  } catch (error) {
    return Promise.reject(error)
  }
}
export const redeemPromoCodes = (params) => async (dispatch) => {
  try {
    const responses = (await Promise.all(
      params.promocodes.map((promocode) => {
        return promoCode.redeemPromoCode({
          merchantId: params.merchantId,
          promoCode: promocode,
        })
      }),
    )).filter((res) => res.success)
    if (!responses.length) {
      return Promise.resolve({ success: false })
    }
    return Promise.resolve(responses)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const removePromoCode = (params) => async (dispatch) => {
  try {
    dispatch(removePromoCodeAction(params))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const completeTakeawayOrder = (qrstring) => async (dispatch, getState) => {
  // > 只有 takeawayStatus === 'ready' 才會顯示 pickupCode 和 QRcode。
  try {
    const token = getState().user.token
    const takeawayOrderId = qrstring.split(':')[1]
    const pickupCode = qrstring.split(':')[2]
    const res = orderApi.completeTakeawayOrder(takeawayOrderId, pickupCode, token)
    return Promise.resolve(res)
  } catch (error) {
    return Promise.reject(error)
  }
}
const calculateAmount = (params) => {
  const { merchant, orders, basket } = params
  const { discountedTotal, discountedTotalWithShipping } = helpers.calculate.calculateOrders(
    orders,
    merchant,
    basket.discount,
    basket.shipping,
  )
  let amount = discountedTotal
  if (basket.isShop || basket.isStoreDelivery) {
    amount = discountedTotalWithShipping
  }
  return amount
}
export const makeWechatPayment = (params) => async () => {
  try {
    const {
      isMobile,
      basket,
      deliveryType,
      deliveryAddress,
      pickupAt,
      dropoffat,
      card,
      ignoreUnavailable,
      merchant,
      orders,
      amount,
    } = params
    const pay_type = isMobile ? 800212 : 800201 // 800212 - H5 , 800201 - QCR
    const out_trade_no = basket.id + '@' + Math.floor(Date.now() / 1000)
    const txamt =
			process.env.REACT_APP_ENV === 'development'
			  ? 10
			  : (amount || calculateAmount({ merchant, basket, orders })) * 100
    const state = {}
    const body = {
      pay_type: pay_type,
      txamt: txamt,
      out_trade_no: out_trade_no,
      txcurrcd: 'HKD',
      extend_info: {
        scene_info: {
          h5_info: {
            type: 'Wap',
            wap_url: 'https://www.dimorder.com/',
            wap_name: 'dimorder',
          },
        },
      },
    }
    const { qrcode, pay_url, syssn } = await orderApi.makeWechatPayment(body)
    Object.assign(state, {
      wechatQRC: qrcode,
      outTradeNo: out_trade_no,
      payUrl: pay_url,
      qrcode: qrcode,
      syssn: syssn,
    })
    const wc_payload = {
      deliveryType,
      card: card,
      ignoreUnavailable: ignoreUnavailable,
      out_trade_no: out_trade_no,
      syssn: syssn,
      takeawayInfo: {
        pickupAt,
        dropoffAt: dropoffat,
        address: deliveryAddress, // google autocomplete address, without optional informations such as floor or room number
      },
    }
    return Promise.resolve({ state, wc_payload })
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getWechatOrderStatus = (orderId) => async () => {
  try {
    const res = await orderApi.getWechatOrderStatus(orderId)
    return Promise.resolve(res)
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/actions/components/basket.js